<template>
    <form :action="confirmationUrl" id="stripe3DSecureAuthConfirmationForm" method="POST" ref="form">
        <input name="_token" type="hidden" v-model="csrfToken">
        <input name="config_id" type="hidden" v-model="configId">
        <input name="storeUsername" type="hidden" v-model="storeUserName">
        <input name="order_id" type="hidden" v-model="orderId">
        <input name="payment_intent_id" type="hidden" v-model="stripeSecureAuthPaymentIntentId">
        <base-dialog-modal :oops="true" @hide="onErrorModalHidden" ref="paymentError" v-if="stripeSecureAuthError">
            <div slot="content">{{stripeSecureAuthError}}</div>
        </base-dialog-modal>
        <base-loading-modal ref="loadingModal">
            <span slot="description">{{loadingMessage}}</span>
        </base-loading-modal>
    </form>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "checkout-payment-stripe-secure-auth",
        data() {
            return {
                failedErrorShown: false,
                confirmationUrl: `${ab.baseUrl}/confirm/checkout/action`,
            }
        },
        mounted() {
            this.$store.dispatch('checkout/handleStripeSecureAuth');
        },
        computed: {
            orderId() {
                return ab.order_id;
            },
            configId() {
                return this.$store.state.currentConfig.id;
            },
            csrfToken() {
                return this.$store.state.csrfToken;
            },
            storeUserName() {
                return ab.user.username;
            },
            loadingMessage() {
                return this.failedErrorShown ? 'Redirecting' : 'Payment in progress';
            },
            ...mapGetters('checkout', [
                'stripeSecureAuthPaymentIntentId',
                'stripeSecureAuthSubmitForm',
                'stripeSecureAuthError'
            ]),
        },
        methods: {
            onErrorModalHidden() {
                this.failedErrorShown = true;
                this.$refs.loadingModal.show();
                this.$router.go(0); // Refresh the page
            }
        },
        watch: {
            stripeSecureAuthError(error) {
                if (error) {
                    this.$nextTick(() => {
                        this.$refs.loadingModal.hide();
                        this.$refs.paymentError.show();
                    });
                }
            },
            stripeSecureAuthSubmitForm(submit) {
                if (submit) {
                    this.$nextTick(() => {
                        this.$refs.loadingModal.show();
                        this.$refs.form.submit();
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>